<template>
  <section class="list">
    <ul class="swiper-wrapper landscape">
      <li
        v-for="(cell, index) in cellList"
        :key="`related_cell_${index}`"
        class="swiper-slide"
      >
        <RelatedLandscapeCell
          :cell-info="cell"
          :thumbnail-info="thumbnailInfo"
          @click-fn="selectCell(cell)"
        />
      </li>
    </ul>
  </section>
</template>

<script>
import _ from 'lodash'
import RelatedLandscapeCell from '@/components/play/bottom-tab/RelatedLandscapeCell'
import utils from '@/common/util/utils'

export default {
  name: 'RelatedCellList',
  components: {
    RelatedLandscapeCell
  },
  props: {
    cellList: {
      type: Array,
      default: null
    },
    thumbnailInfo: {
      type: Object,
      default: () => {}
    },
    contentInfo: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    selectCell (cell) {
      const section = _.get(this.$route, 'params.section', '')
      const id = (section === 'movie') ? 'movieid' : 'contentid'
      const url = `player/${section}?${id}=${cell[id]}`

      utils.common.checkInstallApps(url)
    }
  }
}
</script>
